export default __webpack_public_path__ + "static/media/OTHER_ROCKET.596f9caa.svg";